import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import { decorateJob, jobsListSortMap, jobsSearchCols } from "./_helpers";

// returns: list of draft job openings, ordered by most recently updated first.
export const current_drafts: Query<Ctx> = async ({ sb }, params) => {
  let query = sb.from("v_jobs_list").select("*").eq("job_status", "draft");
  query = applyListParams(query, params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [{ column: "updated_at", ascending: false }],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};
